import { boxToPoints } from ".."
import type { Rectangle2d } from ".."
import type { Edge2dComputed } from "../../mesh"

export const boxToEdges = (box: Rectangle2d): Edge2dComputed[] => {
  const points = boxToPoints(box)
  const segments: Edge2dComputed[] = []
  for (let i = 0; i < points.length; i++) {
    const p1 = points[i]
    const p2 = points[(i + 1) % points.length]
    segments.push({ p1, p2 })
  }

  return segments
}
